import { Directive, ElementRef } from '@angular/core'

@Directive({
  selector: 'img,[brokenImage]',
})
export class BrokenImageDirective {
  constructor (
    private element: ElementRef<HTMLImageElement>,
  ) { }

  ngOnInit () {
    const element = this.element.nativeElement
    if (element.complete && !element.naturalWidth) {
      this.trigger()
    }
    const handler = () => {
      this.trigger()
      element.removeEventListener('error', handler)
    }
    element.addEventListener('error', handler)
  }

  trigger () {
    this.element.nativeElement.src = '/assets/icons/broken-image.svg'
    this.element.nativeElement.style.objectFit = 'none'
  }
}
